import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAppDispatch } from "redux/hooks";
import { resetStep } from "redux/slices/StepSlice";

import { Panel, PanelHeader } from "components";
import Success from "../Success";
import { resetOtp } from "redux/slices/OtpSlice";
import { ResetLogin } from "redux/slices/LoginSlice";
import { resetMerchant } from "redux/slices/MerchantSlice";
import { resetMerchantSwitch } from "redux/slices/MerchantSwitchSlice";
import { resetEmployeeManagement } from "redux/slices/EmployeeManagementSlice";
import { resetAuthList } from "redux/slices/AuthListSlice";
import { resetEmployee } from "redux/slices/EmployeeSlice";
import { resetPassRefInfo } from "redux/slices/password-slices/PasswordRefreshSlice";
import { resetPassRefCardInfo } from "redux/slices/password-slices/PassRefCardInfoSlice";
import { resetServiceError } from "redux/slices/ServiceInlineError";
import { DIGIPOSTHEME } from "theme/digiPosTheme";

const PasswordSuccess: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const handleSuccess = () => {
    dispatch(ResetLogin());
    dispatch(resetOtp());
    dispatch(resetStep());
    dispatch(resetMerchant());
    dispatch(resetMerchantSwitch());
    dispatch(resetEmployeeManagement());
    dispatch(resetAuthList());
    dispatch(resetEmployee());
    dispatch(resetPassRefInfo());
    dispatch(resetPassRefCardInfo());
    dispatch(resetServiceError());
    navigate("/");
  };

  return (
    <Panel width='646px' marginTop='0'>
      <PanelHeader
        backgroundColor={DIGIPOSTHEME.colors.transparent}
        title={t("change_passsword_send_temporary")}
      />
      <Success
        buttonText={t("forgot_password_redirect_login") || ""}
        onClick={handleSuccess}
        noPadding
      />
    </Panel>
  );
};

export default PasswordSuccess;
